import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslocoModule } from '@jsverse/transloco';
// import { NgChartsModule } from 'ng2-charts';
// import { LineChartComponent } from './components/line-chart/line-chart.component';
// import { PieChartComponent } from './components/pie-chart/pie-chart.component';

@NgModule({
  imports: [
    CommonModule,
    MatProgressBarModule,
    // NgChartsModule,
    TranslocoModule,
  ],
  declarations: [
    // LineChartComponent,
    // DoughnutChartComponent,
    // PieChartComponent,
  ],
  exports: [
    // LineChartComponent,
    // NgChartsModule,
    // DoughnutChartComponent,
    // PieChartComponent,
  ],
})
export class ChartJsLibModule {}
